/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */

export type CounsellingType = (typeof CounsellingType)[keyof typeof CounsellingType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CounsellingType = {
  CounsellingSession: 'CounsellingSession',
  CourtSupportCounselling: 'CourtSupportCounselling',
  PsychoEducationalSession: 'PsychoEducationalSession'
} as const;
